import { FC, ReactElement } from 'react'

import { CalendarShift } from '@/containers/Calendar/subcomponents/CalendarShift/CalendarShift'
import { ScheduleShift } from '@/entities/Shift/Shift'

interface CalendarShiftsListProps {
    shifts: ScheduleShift[]
}

export const CalendarShiftsList: FC<CalendarShiftsListProps> = ({ shifts }): ReactElement => (
    <div className="shifts-list">
        {shifts
            .map(shift => {
                return (
                    <CalendarShift
                        key={shift.uuid}
                        shift={shift}
                    />
                )
            })
        }
    </div>
)
